import {
  Alert,
  Container,
  Button,
  Divider,
  Icon,
  Paper,
  Grid,
  Typography,
  styled,
  CircularProgress,
} from '@nextiva/next-ui-components';

export const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.grey[50]};
  height: 148px;
  width: 561px;
  margin: 32px 50px 80px 50px;
  padding: 16px 24px;
  border: 1px dashed ${({ theme }) => theme.palette.blueGrey.A300};
  border-radius: 4px;
  overflow: auto;
` as typeof Container;

export const StyledIcon = styled(Icon)`
  margin-left: 7px;
  color: ${({ theme }) => theme.palette.blueGrey.A400};
`;

export const GrayIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
`;
export const ImportIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
  width: 46px;
`;

export const TileIcon = styled(Icon)`
  margin-top: 30px;
  margin-bottom: 28px;
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
  color: ${({ theme }) => theme.palette.blueGrey.A400};
  font-size: 40px;
`;
export const StyledBox = styled('div')`
  margin: 30px 0 28px 0;
`;

export const BodyGrid = styled(Grid)`
  margin: 56px 0 24px 0;
` as typeof Grid;

export const StyledNameGrid = styled(Grid)`
  word-wrap: break-word;
` as typeof Grid;

export const StyledBody = styled(Typography)`
  margin: 24px 50px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  line-height: 2rem;
`;

export const BottomButton = styled(Button)`
  padding: 0.8rem !important;
`;

export const BottomDivider = styled(Divider)`
  width: 77vw;
  margin-bottom: 16px;
`;

export const StyledImportTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  width: 54%;
`;
export const LongTextButton = styled(Button)`
  &.MuiButton-outlined {
    padding: 12px 32px;
  }
  &.MuiButton-text {
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.5px;
    padding: 0 !important;
  }
`;

export const HiddenInput = styled('input')`
  display: none;
`;

export const Tile = styled(Paper)`
  height: 336px;
  width: 252px;
  margin: 0 24px 24px 0;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(34, 38, 72, 0.16);
  &:hover {
    background-color: ${({ theme }) => theme.palette.info.light};
  }
`;

export const ImportText = styled(Typography)`
  margin: 15px 15px 0px;
  text-align: center;
`;

export const LabelText = styled(Typography)`
  font-weight: 800;
`;

export const BoldText = styled(Typography)`
  font-weight: 800;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;

export const ImportFailed = styled(LabelText)`
  margin-right: 5px;
  color: ${({ theme }) => theme.palette.deepOrange['900']};
`;

export const ImportComplete = styled(LabelText)`
  margin-right: 5px;
  color: ${({ theme }) => theme.palette.teal['700']};
`;

export const GreenIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.teal['700']};
`;

export const RedIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.deepOrange['900']};
`;

export const ImportButton = styled(Button)`
  margin-top: 20px;
`;

export const FileTypeAlert = styled(Alert)`
  width: 560px;
  margin-top: 20px;
`;
export const StyledTypographyMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
export const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
`;
export const StyledRemoveFileButton = styled(Button)`
  margin-left: -16px;
  padding: 0 0 4px 0;
`;
export const StyledFooterGrid = styled(Grid)`
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 16px 40px;
  width: calc(100% - 272px);
  border-top: 1px solid ${({ theme }) => theme.palette.secondary.light};
  background-color: ${({ theme }) => theme.palette.primary.contrastText};
`;

export const StyledFooterButton = styled(Button)`
  line-height: 1rem;
  padding: 12px 24px;
`;
export const StyledSelectedFileGrid = styled(Grid)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
